import { updateHash } from "../../utils/urlHash";
import { LOCAL_ACTIVITY_SEARCH } from "./activityScope";

export const PENDING_REVIEW_SECTION = "review";

/** The local review queue belongs to the signed-in user, independently of session filters. */
export const pendingReviewHref = (userId: string) => ({
  pathname: "/recordings/",
  search: LOCAL_ACTIVITY_SEARCH,
  hash: updateHash(`#${PENDING_REVIEW_SECTION}`, { ru: userId }),
});
